/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $AddressInfo = {
  properties: {
    street: {
      type: 'string',
      isRequired: true,
    },
    number: {
      type: 'string',
      isRequired: true,
    },
    complement: {
      type: 'string',
    },
    neighborhood: {
      type: 'string',
      isRequired: true,
    },
    zipCode: {
      type: 'string',
      isRequired: true,
    },
    city: {
      type: 'string',
      isRequired: true,
    },
    uf: {
      type: 'UF',
      isRequired: true,
    },
    country: {
      type: 'string',
    },
  },
} as const;
